/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { dashboardServices } from "../../../../service/dashboard";
import translationData from '../../../../locales/dashboardTranslation.json'
import { SectionHeaderNew } from "./KpiCardNew";
import { LuActivity, LuClipboardList, LuMicroscope } from "react-icons/lu";

interface LabtestDetailsLayoutProps {
  heading: string;
  selectedDate: any;
}

const columnStyle = {
  margin: "0 0 6px 0",
};

const lastColumnStyle = {
  margin: "0",
};
const LabtestDetailsLayout: React.FC<LabtestDetailsLayoutProps> = ({
  heading,
  selectedDate,
}) => {

  interface ColumnData {
    id: number;
    apiName: string;
    displayName: string;
    count: number;
  }
  const [columnsData, setColumnsData] = useState<ColumnData[]>([]);
  const navigate = useNavigate();

  const navigateToOtherPage = () => {
    // navigate('/labtest-table'); 
  };

  const switchToPage = (id: number) => {
    if (id >= 1 && id <= 7) {
      navigate(`/inner-view-labtest/${id}`);
    }
  }

  const getLabtestStatus = async () => {
    try {
      const response = await dashboardServices.getLabtestStatus(selectedDate);
      if (response.status && response.statusCode === 200) {
        try {
          const responseData = response.data;
          if (responseData) {
            setColumnsData(prevColumnsData => {
              return prevColumnsData.map(column => {
                const { apiName, displayName } = column;

                const apiCount = responseData[apiName];

                if (apiCount !== undefined) {
                  return { ...column, count: apiCount };
                } else {
                  console.warn(`API response for ${displayName} is undefined or missing.`);
                  return column;
                }
              });
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error('user response', error);
    }
  };

  useEffect(() => {
    const LabtestDataHead = translationData.LabtestDataHead;
    setColumnsData(LabtestDataHead.map((item => ({ ...item, count: 0 }))));
    }, []); 

  useEffect(() => {
    getLabtestStatus();
  }, [])

  const getColumnNameStyle = (column: any) => {
    if (column.displayName.includes('outside the range') || column.displayName.includes('Environmental Flora') ) {
      return 'column-style yellowText';
    }else {
      return 'column-style';
    }
  };

  const LabSubSection = ({ title, icon: Icon, items, className }: { title: string, icon?: any, items: { label: string, val: string, color?: string }[], className?: string }) => (
    <div className={`bg-white p-5 rounded-xl border border-slate-100 shadow-sm space-y-4 flex flex-col ${className}`}>
      <div className="flex gap-2 mb-1 border-b border-slate-50 pb-2">
        <div className="w-4 h-4 text-blue-600">
          {Icon && <Icon className="w-4 h-4 text-blue-600" />}
        </div>
        <h4 className="text-[18px] font-semibold uppercase tracking-widest text-slate-800">{title}</h4>
      </div>
      <div className="space-y-3 flex-1 flex flex-col justify-center">
        {items.map((item, idx) => (
          <div key={idx} className="flex justify-between items-center text-xs">
            <span className="font-[500] text-[14px] text-slate-500">{item.label}</span>
            <span className={`font-[700] text-[14px] tracking-tight ${item.color || 'text-blue-700'}`}>{item.val}</span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    // <div className="container">
    //   <h2 className="head-style" title="Click here to View Lab Test Details" onClick={navigateToOtherPage}>
    //     {heading}
    //   </h2>
    //   <div className="columns" style={{ padding: "10px" }}>
    //       {columnsData.map((column) => (
    //       <div key={column.id} className="column" style={column.id === columnsData.length ? lastColumnStyle : columnStyle}>
    //       <div className="linkStyle" onClick={() => switchToPage(column.id)}>
    //       <span className={getColumnNameStyle(column)}>
    //         {column.displayName}
    //       </span>
    //       <span className="countStyle">{column.count}</span>
    //       </div>
    //       </div>
    //   ))}
    //   </div>
    // </div>

    <div className="lg:col-span-8 flex flex-col">
      <SectionHeaderNew title={heading} />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-start">
        <LabSubSection
          title="Lab Testing"
          icon={LuMicroscope}
          className="h-[263.5px]"
          items={[
            {
              label: columnsData?.[0]?.displayName || "Pending for 1st Lab Test",
              val: columnsData?.[0]?.count?.toLocaleString() || "0",
            },
            {
              label: columnsData?.[1]?.displayName || "Pending for 2nd Lab Test",
              val: columnsData?.[1]?.count?.toLocaleString() || "0",
            },
            {
              label: columnsData?.[2]?.displayName || "Pending for 3rd Lab Test",
              val: columnsData?.[2]?.count?.toLocaleString() || "0",
            },
          ]}
        />

        <LabSubSection
          title="Lab Approval"
          icon={LuClipboardList}
          className="h-[263.5px]"
          items={[
            {
              label: columnsData?.[3]?.displayName || "Pending Approval",
              val: columnsData?.[3]?.count?.toLocaleString() || "0",
              color: "text-orange-600",
            },
            {
              label: columnsData?.[4]?.displayName || "Approved",
              val: columnsData?.[4]?.count?.toLocaleString() || "0",
              color: "text-emerald-600",
            },
            {
              label: columnsData?.[5]?.displayName || "Rejected",
              val: columnsData?.[5]?.count?.toLocaleString() || "0",
              color: "text-rose-600",
            },
          ]}
        />

        <LabSubSection
          title="Environmental Flora"
          icon={LuActivity}
          className="h-[263.5px]"
          items={[
            {
              label: columnsData?.[6]?.displayName || "Plates in Flora",
              val: columnsData?.[6]?.count?.toLocaleString() || "0",
              color: "text-orange-600",
            },
          ]}
        />
      </div>
    </div>

  );
};

export default LabtestDetailsLayout;